import React from 'react';
import {Link} from "react-router-dom";
import { useSelector } from 'react-redux';
import AlertCard from "../../theme/cards/AlertCard";
import formatters from "../../../utils/forms/formatters";
import TelephoneNumber from '../TelephoneNumber';


function PPAOptionDisplay({ onApply = () => {} }) {

    const project_id = useSelector(state => state.projectLeads.focusedProject)


    return (
        <>
            <div className="my-4">
                <AlertCard
                    type="info"
                    msg={<>
                            <div className="is-size-4 has-text-weight-semibold">
                                PPAs Work Differently Than Loans
                            </div>
                            <div className="my-4">
                                In a PPA structure, the investor owns a power producing or power storage system and sells the power the system produces back to
                                the "offtaker" at a fixed price. This price is set based on a wide variety of factors, including the value of the
                                tax benefits the system might provide, how much power the system is expected to produce, how much the funder
                                expects to spend to maintain the system, and money market interest rates at the time of financing.
                            </div>
                        <div className="my-4">
                            <div className="button is-text">Learn more about how PPAs work</div>
                        </div>

                        </>
                        }
                    />
                
            </div>

            <div className="my-4">
                <AlertCard
                    type="success"
                    msg={<>
                        <div className="my-4">
                            <span className="has-text-weight-semibold is-size-4">How the PPA Bidding Process Works</span>
                        </div>
                        <div className="my-4">
                            <span className="">If you choose to submit your project for PPA bids, please upload your project files via the button below.  
                            Your project will be instantly presented to those in our network of investors interested in that specific project profile. Responding investors will offer rate, 
                            terms, conditions and notes specific to your project within approximately 4 working days.  Investors are not obligated to respond. </span>
                        </div>
                        <div className="my-4">Once you have reviewed the offers presented then selected the investor you and your off-taker wish to work with, the off-taker will submit financial documents
                        for a full credit underwriting. This will be coordinated by a CleanFi teammember. Over the course of that process, barring negative findings in the credit underwriting process, you and the off-taker will receive a term-sheet 
                        </div>
                        <div className="my-4">
                            {/* <div className="button is-text">Learn more about our bidding process</div> */}
                            <p>Call us with questions and we're happy to walk you through the process. <span className='is-primary has-text-weight-semibold'> <TelephoneNumber /></span> </p>
                        </div>
                    </>}
                />
            </div>
            <div className="my-4">
                <div className="card">
                    <div className="card-content">
                        {/* <Link to={`/ppa-apply/${project_id}`}> */}
                            <div 
                                className="button is-link is-large"
                                onClick={onApply}
                            >
                                Enter your project in BidDesk
                            </div>
                        {/* </Link> */}
                        <div className="my-6 content">
                            <p>Some documents you'll need to apply:</p>
                            <ul >
                                <li>
                                    Contractor Agreement
                                </li>
                                <li>
                                    System Production Design and Analysis (Energy Tool Base or similar)
                                </li>
                                <li>
                                    Utility Bills
                                </li>
                                <li>
                                    A signed copy of the off-taker's request for a PPA proposal. <a href="https://docs.google.com/document/d/1S7R9BNexs25gUXOnutjKnz6UZj31epVer_ywWWxaOT4/edit">Download a template here.</a>
                                </li>
                                {/* <li>
                                    Organizational Docs for Entity Applying
                                </li>
                                <li>
                                    Three years of financials
                                </li> */}
                            </ul>

                            <p>You can always come back to an application after you've started it, by clicking on the
                            "Applications" tab of <Link to="/my-projects">My Projects</Link></p>

                        </div>

                    </div>
                </div>
            </div>


        </>
    )

}



export default PPAOptionDisplay;